import { SET_PEOPLE_COUNTER_DATA, CLEAR_PEOPLE_COUNTER_DATA, SET_PEOPLE_COUNTER_PAGE_NUMBER } from "../types";

export const setPeopleCounterData = (data) => ({
    type: SET_PEOPLE_COUNTER_DATA,
    payload: {
        data,
    }
});

export const clearPeopleCounterData = () => ({
    type: CLEAR_PEOPLE_COUNTER_DATA,
})

export const setPeopleCounterPageNumber = (pageNumber) => ({
    type: SET_PEOPLE_COUNTER_PAGE_NUMBER,
    payload: pageNumber,
})
